export default __webpack_public_path__ + "static/media/S75.86b7a804.png";